module.exports = __webpack_public_path__ + "static/media/foot-right-back.2430b319.png";